import { useAuth } from "../context/AuthContext"

export default function ChatPMFAST() {
  const { user } = useAuth()
  return <div>Bienvenido al Chat PMFAST, {user?.nombre || "usuario"}.</div>
}
